export default __webpack_public_path__ + "static/media/IMG_6566.ba7f9aca.webp";